// DataExplorer constants and configuration

export const TABS = {
  MAP: 'map',
  GALLERY: 'gallery',
  OBSERVATIONS: 'observations',
}

export const TAB_LABELS = {
  [TABS.MAP]: 'Map',
  [TABS.GALLERY]: 'Gallery',
  [TABS.OBSERVATIONS]: 'Observations',
}

export const VIEW_MODES = {
  GRID: 'grid',
  MASONRY: 'masonry',
}

// Masonry layout configuration
export const MASONRY_CONFIG = {
  AREA_CYCLE: ['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7'],
  CHUNK_SIZE: 7,
}

